/* globals _ */

import Model from './base';

import library from '../../data/methods';

const { findWhere } = _;

export default Model.extend( {
	key: 'category',

	defaults: {
		slug: '',
		name: '',
		verb: '',
		by: '',
	},

	constructor: function( attributes, options ) {
		if ( typeof attributes === 'string' ) {
			attributes = findWhere( library, { id: attributes } );
		}

		return Model.prototype.constructor.call( this, attributes, options );
	},
} );
